import React from 'react';

const AddIcon = ({ width = 13, height = 13, color = '#AAA2AA', ...rest }) => (
  <svg
    viewBox="0 0 13 13"
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...rest}
  >
    <path
      d="M6.309 1v11M.971 6.5h10.676"
      fill="none"
      fillRule="evenodd"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.8}
    />
  </svg>
);

export default AddIcon;
